module.exports = __webpack_public_path__ + "static/img/mail-game-1.fd54f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail-game-1.png
// module id = R2Tp
// module chunks = 1